import axios from 'axios';

export const SET_WORKSPACE_MEMBERS_LIST = 'SET_WORKSPACE_MEMBERS_LIST';
export const SET_WORKSPACE_MEMBERS_LOADING = 'SET_WORKSPACE_MEMBERS_LOADING';
export const TOGGLE_WORKSPACE_MEMBER_ACTIVE = 'TOGGLE_WORKSPACE_MEMBER_ACTIVE';

export const getMembers = (wId, { page = 1, limit = 10, search = '', is_active = true } = {}) => async (dispatch) => {
  dispatch({ type: SET_WORKSPACE_MEMBERS_LOADING, loading: true });
  try {
    const params = { page, limit, is_active };
    if (search) params.search = search;
    const res = await axios.get(`/api/${wId}/members`, { params });
    if (res.data.success) {
      dispatch({
        type: SET_WORKSPACE_MEMBERS_LIST,
        tab: is_active ? 'active' : 'inactive',
        members: res.data.members,
        pagination: res.data.pagination,
      });
    }
  } catch (err) {
    console.error('getMembers', err);
  } finally {
    dispatch({ type: SET_WORKSPACE_MEMBERS_LOADING, loading: false });
  }
};

export const toggleMemberActive = (wId, wmId, is_active) => async (dispatch) => {
  try {
    const res = await axios.put(`/api/w/${wId}/membership/${wmId}`, { is_active });
    if (res.data.success) {
      dispatch({ type: TOGGLE_WORKSPACE_MEMBER_ACTIVE, wmId, is_active });
    }
    return res;
  } catch (err) {
    console.error('toggleMemberActive', err);
    throw err;
  }
};

export const bulkActivateMembers = (wId, wmIds) => async () => {
  try {
    const res = await axios.put(`/api/w/${wId}/memberships/bulk-activate`, { wmIds });
    return res.data;
  } catch (err) {
    console.error('bulkActivateMembers', err);
    throw err;
  }
};
